import { Trans, useLingui } from "@lingui/react/macro";

import { Locale, setLocale } from "~/service/i18n.ts";
import { AButton } from "~/ui/base/AButton.tsx";
import { createWebDraggableSheet } from "~/ui/base/WebDraggableSheet.tsx";

export const WebLanguageSheet = createWebDraggableSheet(
  ({ close, titleId }) => {
    const { t } = useLingui();
    return (
      <div>
        <h1
          className="pb-4 text-lg font-semibold text-zinc-800 dark:text-zinc-100"
          id={titleId}
        >
          <Trans>언어 선택</Trans>
        </h1>
        {[
          {
            label: "한국어" as const,
            locale: Locale.KO,
            translatedLabel: t`한국어`,
          },
          {
            label: "English" as const,
            locale: Locale.EN,
            translatedLabel: t`영어`,
          },
          {
            label: "日本語" as const,
            locale: Locale.JA,
            translatedLabel: t`일본어`,
          },
        ].map(({ label, locale, translatedLabel }) => (
          <AButton
            className="w-full rounded-xl py-3 text-start duration-150 active:scale-[98%] disabled:opacity-80"
            key={label}
            onClick={async () => {
              await setLocale(locale);
              close();
            }}
          >
            <p className="text-zinc-800 dark:text-zinc-100">{label}</p>
            <p className="mt-0.5 text-sm text-zinc-500 dark:text-zinc-400">
              {translatedLabel}
            </p>
          </AButton>
        ))}
      </div>
    );
  },
);
